import { useFormManagement } from "./form/useFormManagement";

import { HeaderContainer, TitleContainer } from "./style";
import FallForm from "./form";
import { BigBoldText, useAnalyticsWrapper } from "./form/sharedImports";
import GeneralForm from "../../../../components/Forms/generalForm/GeneralForm";
import { modifyTitle } from "../../../../utils/helpers/analyticsUtils";
import DropdownModal from "../../../../components/DropdownModal/DropdownModal";

import { IoMdClose } from "react-icons/io";
type FilterModalProps = {
  open: boolean;
  closeFn: () => void;
  filterType: string;
  subtitle: string;
  isModifyMode?: boolean;
};

const FilterModal = ({
  open,
  closeFn,
  filterType,
  subtitle,
  isModifyMode = false,
}: FilterModalProps) => {
  const {
    facilityOptions,
    isFetching,
    setFieldValue,
    handleSubmit,
    values,
    isSubmitDisabled,
  } = useFormManagement({ submitFn: closeFn });

  const { fallFacility, startDate, endDate, trendSelectedFacility } =
    useAnalyticsWrapper((state) => ({
      fallFacility: state.fallFacility,
      startDate: state.startDate,
      endDate: state.endDate,
      trendSelectedFacility: state.trendSelectedFacility,
    }));

  return (
    <DropdownModal isOpen={open}>
      <HeaderContainer className="mb-7">
        <TitleContainer>
          <BigBoldText style={{ color: "#b580ff" }}>
            Update Query - {modifyTitle(subtitle)}
          </BigBoldText>
        </TitleContainer>
        <IoMdClose
          onClick={() => {
            closeFn();
          }}
          style={{ color: "#b580ff" }}
          className="cursor-pointer border-0 bg-purple-100 bg-transparent text-2xl font-medium"
        />
      </HeaderContainer>

      {filterType === "general" ? (
        <GeneralForm
          closeFn={closeFn}
          bottom={true}
          initialFacility={trendSelectedFacility}
          initialStartDate={startDate}
          initialEndDate={endDate}
          isModifyMode={isModifyMode}
        />
      ) : (
        <FallForm
          formName="fallOnScreen"
          handleSubmit={handleSubmit}
          facilityOptions={facilityOptions}
          setFieldValue={setFieldValue}
          values={values}
          closeFn={closeFn}
          isSubmitDisabled={isSubmitDisabled}
          isFetching={isFetching}
          bottom={true}
          fallFacility={fallFacility}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </DropdownModal>
  );
};

export default FilterModal;
